var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.3H4.3V4V1C4.3 0.814349 4.37375 0.636301 4.50503 0.505025C4.6363 0.37375 4.81435 0.3 5 0.3H17C17.1857 0.3 17.3637 0.37375 17.495 0.505025C17.6263 0.6363 17.7 0.814348 17.7 1V15C17.7 15.1857 17.6263 15.3637 17.495 15.495C17.3637 15.6263 17.1857 15.7 17 15.7H14H13.7V16V19C13.7 19.3846 13.3861 19.7 12.993 19.7L1.007 19.7L1.0052 19.7C0.91285 19.7006 0.8213 19.6829 0.735812 19.6479C0.650321 19.613 0.572578 19.5615 0.507049 19.4964C0.44152 19.4314 0.389494 19.354 0.353961 19.2687C0.318451 19.1835 0.300113 19.0922 0.3 18.9999L0.303 5.00006V5C0.303 4.61524 0.617125 4.3 1.009 4.3H4ZM2.002 5.7H1.70205L1.702 5.99995L1.7 18L1.69995 18.3H2H12H12.3V18V6V5.7H12H2.002ZM5.7 4V4.3H6H13.7V14V14.3H14H16H16.3V14V2V1.7H16H6H5.7V2V4ZM4.3 9.3H9.7V10.7H4.3V9.3ZM4.3 13.3H9.7V14.7H4.3V13.3Z",
    fill: "white",
    stroke: "#383A35",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoForm);
export default __webpack_public_path__ + "static/media/ico-form.60eabd881851d133cdb1c257ce5c7e71.svg";
export { ForwardRef as ReactComponent };